import { useIntl } from '@alltrails/shared/react-intl';
import { AlgoliaSearchBox } from '@alltrails/modules/AlgoliaSearch';
import useExperiments from 'hooks/useExperiments';
import useExposureEvent from 'hooks/useExposureEvent';
import '@alltrails/modules/AlgoliaSearch/index.css';
import SearchOrigin from '@alltrails/analytics/enums/SearchOrigin';
import * as styles from './styles/styles.module.scss';

type SearchBoxProps = {
  placeholder?: string;
};

const SearchBox = ({ placeholder }: SearchBoxProps) => {
  const intl = useIntl();
  const experiments = useExperiments();
  const aiSearchEnabled = experiments['web-ai-natural-language-search']?.value === 'treatment';
  const typeAheadEnabled = experiments['web-disco-rm-type-ahead']?.value === 'treatment';
  const sendTypeAheadExposure = useExposureEvent('web-disco-rm-type-ahead');

  return (
    <div className={styles.searchBox}>
      <AlgoliaSearchBox
        clearOnSelect
        configs={global.__AT_DATA__.algoliaConfig}
        dropdownVariant="enveloping"
        aiSearchEnabled={aiSearchEnabled}
        navigateOnSelect
        onInputFocus={sendTypeAheadExposure}
        onResultSelect={() => {
          // Do nothing
        }}
        placeholder={placeholder || intl.formatMessage({ defaultMessage: 'Search' })}
        searchOrigin={SearchOrigin.GlobalNav}
        searchTypes="all"
        testId="header-search"
        useTypeAhead={typeAheadEnabled}
        variant="subtle"
      />
    </div>
  );
};
export default SearchBox;
